import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

import FinancingInfoList from './components/financing-info-list.js'
import {FinancingInfoTermsPartner} from './components/financing-info-terms-partner.js'

const BASE_CLASS = 'mt-TableFinancingDetails'

export const TableFinancingDetails = ({
  financingData,
  hideLegalConditionsLink = false,
  isLink = true,
  isModal = false,
  onClickTerms = () => {}
}) => {
  const {domain} = useContext(Context)

  const config = domain.get('config')

  const {FINANCING_PARTNERS} = config.get('financing')

  const {lender} = financingData

  const isSantanderPriLender = FINANCING_PARTNERS.SANTANDER_PRI === lender

  const showLink = ((useMediaQuery(useMediaQueryBreakpoints.sm) && isLink) || !isLink) && !hideLegalConditionsLink

  const classNames = cx(BASE_CLASS, isSantanderPriLender && `${BASE_CLASS}--santanderPriLender`)

  return (
    <div className={classNames}>
      <FinancingInfoList financingData={financingData} isModal={isModal} />
      {showLink && (
        <FinancingInfoTermsPartner
          financingData={financingData}
          isLink={isLink}
          isModal={isModal}
          onClickTerms={onClickTerms}
        />
      )}
    </div>
  )
}

TableFinancingDetails.displayName = 'TableFinancingDetails'

TableFinancingDetails.propTypes = {
  financingData: PropTypes.shape({
    availableTerm: PropTypes.bool,
    capital: PropTypes.number,
    coefficient: PropTypes.number,
    commissionEur: PropTypes.number,
    dateFirstInstallment: PropTypes.string,
    dateSignup: PropTypes.string,
    fee: PropTypes.number,
    firstFee: PropTypes.number,
    hasSpecificLegalConditions: PropTypes.bool,
    id: PropTypes.string,
    lender: PropTypes.string,
    lifeInsuranceAmount: PropTypes.number,
    maxEntry: PropTypes.number,
    minEntry: PropTypes.number,
    openingExpenses: PropTypes.number,
    openingPercentage: PropTypes.number,
    tae: PropTypes.number,
    terms: PropTypes.number,
    tin: PropTypes.number,
    totalAmountDue: PropTypes.number,
    totalInterest: PropTypes.number,
    totalLoanAmount: PropTypes.number,
    totalLoanCost: PropTypes.number,
    totalPriceTerms: PropTypes.number,
    totalTermsAmount: PropTypes.number
  }).isRequired,
  hideLegalConditionsLink: PropTypes.bool,
  isLink: PropTypes.bool,
  isModal: PropTypes.bool,
  onClickTerms: PropTypes.func
}

export default TableFinancingDetails
